
export default class RatesModel {
    constructor (
        _to = "",
        _from = "",
        _rate = "",
        _status = 1
    ) {
      this.to   = _to;
      this.from = _from;
      this.rate = _rate,
      this.status = _status;
    }
  }
  